import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { IOverlayLoaderStore } from '../../../common/OverlayLoader.store';
import { JobAnnotationTools } from '../../components/details/JobAnnotationTools';
import { IJobDetailsService } from '../../jobDetails.service';
import { IJobDetailsFormsBl } from '../../jobDetailsForms.bl';
import { useJobPermissions } from '../../jobPermissions';
import { JOB_STATUS } from '../../jobs.model';
import { withValidType } from './withValidType';

export const JobAnnotationToolsContainer = withValidType(
  observer((): React.ReactElement => {
    const jobDetailsService = useInjection(IJobDetailsService.$);
    const overlayLoader = useInjection(IOverlayLoaderStore.$);
    const jobDetailsForms = useInjection(IJobDetailsFormsBl.$);
    const permissions = useJobPermissions();

    const toggleAnnotationTool = (e: React.ChangeEvent<HTMLInputElement>): void => {
      jobDetailsForms.toggleAnnotationTool(e.target.value);
    };

    const {
      annotationTools,
      job: { isOwner, status, annotationToolIds },
    } = jobDetailsService.store;
    const isLoading = status === JOB_STATUS.UNKNOWN || overlayLoader.isSpinnerVisible('job-annotation-tools-table');
    const editableStatus = status === JOB_STATUS.DRAFT || status === JOB_STATUS.STOPPED || status === JOB_STATUS.FAILED;
    const hasPermissions = permissions.canUpdate(isOwner).allowed;

    return (
      <JobAnnotationTools
        isFormDisabled={isLoading || !editableStatus || !hasPermissions}
        annotationTools={annotationTools}
        annotationToolIds={annotationToolIds}
        toggleAnnotationTool={toggleAnnotationTool}
        isLoading={isLoading}
        toggleAllAnnotationTools={() => {
          jobDetailsForms.toggleAllAnnotationTools({ forceAll: false });
        }}
      />
    );
  })
);
